import { FC } from 'react'

import CheckMarkIcon from 'src/Assets/Svg/pages-icons/CheckMark.svg?react'
import TikTokIconLight from 'src/Assets/Svg/tiktok_light.svg?react'
import TikTokIcon from 'src/Assets/Svg/platform-icons/TikTok.svg?react'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { useThemeMode } from 'src/Hooks/useThemeMode'

import { CrossSellPlatform, crossSellCardConfig } from '../helpers'

import {
  Card,
  Header,
  IconWrapper,
  Chip,
  TextBlock,
  Title,
  Description,
  Checks,
  CheckItem,
  CheckIconWrapper,
  CheckText,
  Footer,
  Footnote,
  StyledGreyTextButton,
} from './styles'

interface Props {
  platform: CrossSellPlatform
  ctaText?: string | null
  onClick: () => void
}

export const CrossSellCard: FC<Props> = ({ platform, ctaText, onClick }) => {
  const { resolvedTheme } = useThemeMode()
  const {
    Icon: ConfigIcon,
    chipLabel,
    title,
    description,
    checks,
    footnote,
    ctaText: defaultCtaText,
  } = crossSellCardConfig[platform]

  const isTikTok = platform === CampaignPlatformTypeEnum.TIKTOK
  const isDark = resolvedTheme === 'dark'
  const TikTokResolved = isDark ? TikTokIconLight : TikTokIcon
  const Icon = isTikTok ? TikTokResolved : ConfigIcon

  return (
    <Card>
      <Header>
        <IconWrapper
          $usesCurrentColor={
            platform === CampaignPlatformTypeEnum.TIKTOK &&
            resolvedTheme !== 'dark'
          }
        >
          <Icon />
        </IconWrapper>
        <Chip>{chipLabel}</Chip>
      </Header>

      <TextBlock>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Checks>
          {checks.map((check) => (
            <CheckItem key={check}>
              <CheckIconWrapper>
                <CheckMarkIcon width={16} height={16} />
              </CheckIconWrapper>
              <CheckText>{check}</CheckText>
            </CheckItem>
          ))}
        </Checks>
      </TextBlock>

      <Footer>
        <StyledGreyTextButton onClick={onClick}>
          {ctaText ?? defaultCtaText}
        </StyledGreyTextButton>
        <Footnote>{footnote}</Footnote>
      </Footer>
    </Card>
  )
}
